import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Container = styled.div<{ ref: any }>`
  position: relative;
  display: inline-flex;
`

export const Trigger = styled.button`
  display: flex;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    transform: scale(1.15);
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`

export const Dropdown = styled(motion.div)`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 10;
`

export const BallButton = styled(motion.button)`
  display: flex;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.18));
`

export const BallInner = styled.div`
  display: flex;
  transition: transform 0.14s ease;
  will-change: transform;
  transform: scale(1);

  ${BallButton}:hover & {
    transform: scale(1.2);
  }

  ${BallButton}:active & {
    transform: scale(0.92);
  }
`
